import { ReactNode, useMemo, useState } from "react";
import { DetailPanelContext } from "./DetailPanelContext.ts";

interface DetailPanelState {
  open: boolean;
  content: ReactNode;
  onClose?: () => void;
  attributes?: Record<string, unknown>;
}

export const useDetailPanelState = (): {
  detailPanelState: DetailPanelState;
  detailPanelContext: DetailPanelContext;
} => {
  const [detailPanelState, setDetailPanelState] = useState<DetailPanelState>({
    open: false,
    content: null,
  });

  return useMemo(() => {
    const closePanel = () =>
      setDetailPanelState((prevState) => {
        prevState.onClose?.();
        return { open: false, content: null };
      });

    return {
      detailPanelState,
      detailPanelContext: {
        openPanel: (node, { onClose, attributes } = {}) =>
          setDetailPanelState((prevState) => {
            prevState.onClose?.();
            return {
              open: true,
              content: node,
              onClose,
              attributes,
            };
          }),
        closePanel,
        attributes: detailPanelState.attributes,
      },
    };
  }, [detailPanelState]);
};
